import {
  Dispatch,
  FC,
  Fragment,
  LegacyRef,
  MutableRefObject,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import * as Yup from 'yup'
import axios from 'axios'
import {Invoice, InvoiceRowForm} from '../../core/_models'
import {
  fixZero,
  API_URL,
  isAPP,
  isMegaPay,
  isNotEmpty,
  isPOS,
  numberWithCommas,
} from '../../../../../../../_metronic/helpers'
import clsx from 'clsx'
import {CustomInputs} from '../../../../../../../_metronic/helpers/components/CustomInputs'
import {
  SearchSelect,
  SearchSelectOption,
} from '../../../../../../../_metronic/helpers/components/SearchSelect'
import {useListView} from '../../core/ListViewProvider'
import {ProductEditModal} from '../../../../product-management/products-list/product-edit-modal/ProductEditModal'
import {getProductById} from '../../../../product-management/products-list/core/_requests'
import {Product} from '../../../../product-management/products-list/core/_models'
import {StuffIdInfo} from '../../../../product-management/products-list/product-edit-modal/StuffIdInfo'
import {Stuffid} from '../../../../stuffid-management/stuffids-list/core/_models'
import {getStuffidByCode} from '../../../../stuffid-management/stuffids-list/core/_requests'
import {StepProduct} from '../itemSimple/steps/stepProduct'
import {GoldPriceCal} from './GoldPriceCal'
import {borderRightWidth} from 'html2canvas/dist/types/css/property-descriptors/border-width'
import {borderTopRightRadius} from 'html2canvas/dist/types/css/property-descriptors/border-radius'
import {DiscountPriceCal} from './DiscountPriceCal'
import {Template3Fields} from './Template3Fields'
import {useAuth} from '../../../../../auth'
import {
  getCurrencyAmountValidationError,
  getThirdPartyContractNumberValidationError,
  isZeroVatInvoiceTemplate,
  normalizeThirdPartyContractNumberInput,
  THIRD_PARTY_CONTRACT_NUMBER_LENGTH,
} from '../../core/invoicePatternValidation'
import {
  isTemplate11,
  isValidTemplate11Adis,
  resolveTemplate11UnitAmount,
  TEMPLATE_11_ADIS_WHOLE_NUMBER_ERROR,
  TEMPLATE_11_TOO_LARGE_ERROR,
  toTemplate11SubmitRow,
} from '../../core/invoiceTemplate11'
import {
  hasOrganizationUnitCode,
  isInvoiceFieldReadOnly,
  isInvoiceFieldVisible,
  InvoiceRulesV79,
  resolveInvoiceUnitRule,
} from '../../core/invoiceRulesV79'
import {CODELESS_UNIT_HINT, isCodelessUnitLabel, unitLabelOf} from '../../core/invoiceUnitCode'
import {InvoiceSubject} from '../../core/invoiceSubject'
import {getInvoiceErrorMessage} from '../../core/invoiceError'
import {Alert} from '../../../../../../../_metronic/helpers/components/Alert'
import {GoldCostPriceEntryStep} from './GoldCostPriceEntryStep'
import {
  isValidGoldQuantityDecimalPlaces,
  loadGoldQuantityDecimalPlacesPreference,
  saveGoldQuantityDecimalPlacesPreference,
} from './goldCostPricePreferences'
import {ThirdPartyContractPicker} from './ThirdPartyContractPicker'
import {toPersianDigits} from '../../../../../../../_metronic/helpers/components/datepicker/persianDateValue'
import './InvoiceItemEditModalForm.css'

type GoldCostPriceCalculation = {
  unitPrice: string
  quantity: string
  price: string
  discount: string
  wage: string
  profit: string
  commission: string
  adPrice: string
  vatRate: string
  vatPrice: string
  netPrice: string
  quantityDecimalPlaces: number
}

type Props = {
  invoiceItem: {
    invoiceItem: InvoiceRowForm | null | undefined
    setInvoiceItem: React.Dispatch<React.SetStateAction<InvoiceRowForm | null | undefined>>
  }
  items: {
    items: InvoiceRowForm[]
    setItems: Dispatch<SetStateAction<InvoiceRowForm[]>>
  }
  invoiceTemplate: number
  invoiceType: number
  invoiceSubject: InvoiceSubject
  invoiceDate: string
  formType: number
  amountMustEqualOne?: boolean
  rules?: InvoiceRulesV79
  productionInvoice?: boolean
}

const InvoiceItemEditModalForm: FC<Props> = ({
  invoiceItem,
  items,
  invoiceTemplate,
  invoiceType,
  invoiceSubject,
  invoiceDate,
  formType,
  amountMustEqualOne,
  rules,
  productionInvoice,
}) => {
  const {variableC, variableD} = useListView()
  const {currentUser} = useAuth()
  const valueAddedNotCalled =
    currentUser?.cpl?.find((company) => company.id == currentUser.cpi)?.vnc == true
  const zeroVatTemplate = isZeroVatInvoiceTemplate(invoiceTemplate)
  const forceZeroVat = valueAddedNotCalled || zeroVatTemplate
  const unitRule = resolveInvoiceUnitRule(rules, invoiceType, invoiceTemplate, invoiceSubject)
  const unitRequired = unitRule.required
  const unitVisible = unitRule.visible
  const thirdPartyContractNumberVisible = isInvoiceFieldVisible(
    rules,
    'bsrn',
    invoiceSubject !== 3 && invoiceTemplate !== 11
  )
  const thirdPartyContractNumberReadOnly = isInvoiceFieldReadOnly(rules, 'bsrn')
  const [first, setFirst] = useState(true)
  const [isLoaded, setIsLoaded] = useState(
    !(invoiceItem.invoiceItem && isNotEmpty(invoiceItem.invoiceItem))
  )
  const [productSelected, setProductSelected] = useState<Product>()
  const [productId, setProductId] = useState<number>()
  const [product, setProduct] = useState<Product>()
  const [description, setDescription] = useState<string>()
  const [fee, setFee] = useState<string>('')
  const [qty, setQty] = useState<string>('')
  const [unit, setUnit] = useState<SearchSelectOption>()
  const [discount, setDiscount] = useState<string>('')
  const [carat, setCarat] = useState<string>('750')
  const [contractNo, setContractNo] = useState<string>()
  const contractNoError = thirdPartyContractNumberVisible
    ? getThirdPartyContractNumberValidationError(contractNo)
    : ''

  const [wage, setWage] = useState<string>('')
  const [profit, setProfit] = useState<string>('0')
  const [commission, setCommission] = useState<string>('0')

  const [wageRate, setWageRate] = useState<string>('')
  const [profitRate, setProfitRate] = useState<string>('')
  const [commissionRate, setCommissionRate] = useState<string>('')

  const [wageShow, setWageShow] = useState<boolean>(true)
  const [profitShow, setProfitShow] = useState<boolean>(true)
  const [commissionShow, setCommissionShow] = useState<boolean>(true)

  const [contract, setContract] = useState<string>('')
  const [vatRate, setVatRate] = useState<number>(0)
  const [vatRateManuallyChanged, setVatRateManuallyChanged] = useState<boolean>(
    invoiceItem.invoiceItem?.vatRateManuallyChanged === true
  )

  const [taxName, setTaxName] = useState<string>('')
  const [taxRate, setTaxRate] = useState<string>('')

  const [govTaxName, setGovTaxName] = useState<string>('')
  const [govTaxRate, setGovTaxRate] = useState<string>('')

  const [priceCalShow, setPriceCalShow] = useState(false)
  const [stuffInfoOpen, setStuffInfoOpen] = useState(false)
  const [showAdditionalFields, setShowAdditionalFields] = useState(() => {
    const currentItem = invoiceItem.invoiceItem
    if (!currentItem) return false

    return Boolean(
      currentItem.taxName ||
        currentItem.taxRate ||
        currentItem.govTaxName ||
        currentItem.govTaxRate ||
        currentItem.contractNo ||
        currentItem.weight ||
        currentItem.vatBaseAmount ||
        (invoiceTemplate != 2 &&
          invoiceTemplate != 7 &&
          (currentItem.amountCurrency || currentItem.currency || currentItem.currencyRate))
    )
  })

  const [_isAPP, set_isAPP] = useState(isAPP || formType)
  const [rounding, setRounding] = useState(false)

  const [onPercent, setOnPercent] = useState(true)

  const [total, setTotal] = useState('')
  const [goldCostPriceCalculation, setGoldCostPriceCalculation] =
    useState<GoldCostPriceCalculation>()
  const [goldCostPriceError, setGoldCostPriceError] = useState('')
  const [isGoldCostPriceCalculating, setIsGoldCostPriceCalculating] = useState(false)
  const [goldQuantityDecimalPlaces, setGoldQuantityDecimalPlaces] = useState(() =>
    loadGoldQuantityDecimalPlacesPreference(currentUser?.id, currentUser?.cpi)
  )

  const [currencyValue, setCurrencyValue] = useState<string>('')
  const [amountCurrency, setAmountCurrency] = useState<string>('')
  // Sent as cfee in every pattern but 5, 7 (its currency value goes as sscv) and 11.
  const amountCurrencyError = [5, 7, 11].includes(invoiceTemplate)
    ? ''
    : getCurrencyAmountValidationError(amountCurrency)
  const [currencyRate, setCurrencyRate] = useState<string>('')
  const [currencyPurchaseRate, setCurrencyPurchaseRate] = useState<string>('')
  const [vatBaseAmount, setVatBaseAmount] = useState<string>('')
  const [weight, setWeight] = useState<string>('')
  const [currency, setCurrency] = useState<SearchSelectOption>()
  // الگوی ۱۱ (بورس کالا): فقط «مبلغ بعد از تخفیف» (adis) از کاربر گرفته می‌شود؛ مبلغ واحد محاسباتی است
  const template11 = isTemplate11(invoiceType, invoiceTemplate)
  const [adis, setAdis] = useState<string>('')
  const hasAdditionalFields =
    !template11 &&
    ((formType == 0 && !_isAPP) || invoiceTemplate == 7 || invoiceTemplate == 9)

  useEffect(() => {
    if (amountMustEqualOne) setQty('1')
  }, [amountMustEqualOne])

  useEffect(() => {
    setGoldQuantityDecimalPlaces(
      loadGoldQuantityDecimalPlacesPreference(currentUser?.id, currentUser?.cpi)
    )
  }, [currentUser?.id, currentUser?.cpi])

  useEffect(() => {
    if (first) {
      if (invoiceItem.invoiceItem && isNotEmpty(invoiceItem.invoiceItem)) {
        setVatRate(forceZeroVat ? 0 : invoiceItem.invoiceItem.vatRate || 0)
        setVatRateManuallyChanged(invoiceItem.invoiceItem.vatRateManuallyChanged === true)
        setProductId(invoiceItem.invoiceItem.productId)
        setDescription(invoiceItem.invoiceItem.description)
        setFee((invoiceItem.invoiceItem.amount || 0).toString())
        setUnit(invoiceItem.invoiceItem.unit)

        setCurrency(invoiceItem.invoiceItem.currency)
        setCurrencyValue((invoiceItem.invoiceItem.currencyValue || 0).toString())
        setAmountCurrency((invoiceItem.invoiceItem.amountCurrency || 0).toString())
        setCurrencyRate((invoiceItem.invoiceItem.currencyRate || 0).toString())
        setCurrencyPurchaseRate((invoiceItem.invoiceItem.currencyPurchaseRate || 0).toString())
        setVatBaseAmount((invoiceItem.invoiceItem.vatBaseAmount || 0).toString())
        setWeight((invoiceItem.invoiceItem.weight || 0).toString())

        setQty((invoiceItem.invoiceItem.qty || 1).toString())
        setDiscount((invoiceItem.invoiceItem.discount || 0).toString())
        setContractNo(invoiceItem.invoiceItem.contractNo?.toString() ?? '')
        setCarat((invoiceItem.invoiceItem.carat || 0).toString())
        if (template11) {
          const storedAdis = [
            invoiceItem.invoiceItem.adis,
            invoiceItem.invoiceItem.adPrice,
            invoiceItem.invoiceItem.price,
          ].find((value) => value != undefined && Number.isFinite(value))
          setAdis(storedAdis != undefined ? storedAdis.toString() : '')
        }

        setWage((invoiceItem.invoiceItem.wage || 0).toString())
        console.info(
          'invoiceItem',
          invoiceItem.invoiceItem,
          invoiceItem.invoiceItem.wage,
          invoiceItem.invoiceItem.profit,
          invoiceItem.invoiceItem.commission
        )
        setProfit((invoiceItem.invoiceItem.profit || 0).toString())
        setCommission((invoiceItem.invoiceItem.commission || 0).toString())

        setGovTaxName(invoiceItem.invoiceItem.govTaxName || '')
        setGovTaxRate(
          invoiceItem.invoiceItem.govTaxRate ? invoiceItem.invoiceItem.govTaxRate.toString() : ''
        )

        setTaxName(invoiceItem.invoiceItem.taxName || '')
        setTaxRate(
          invoiceItem.invoiceItem.taxRate ? invoiceItem.invoiceItem.taxRate.toString() : ''
        )

        setTimeout(() => {
          setIsLoaded(true)
        }, 1000)
      }
      setFirst(false)
    }
  }, [])

  useEffect(() => {
    if (isLoaded) {
      setProductId(
        productSelected && isNotEmpty(productSelected.id) ? Number(productSelected.id) : undefined
      )
    }
  }, [productSelected])

  useEffect(() => {
    //if (!first && !(invoiceItem.invoiceItem && isNotEmpty(invoiceItem.invoiceItem)) && productId) {
    if (!product && productId) {
      getProductById(productId, invoiceDate).then((response) => {
        if (response) {
          setProduct(response)
        }
      })

      setTimeout(() => {
        var elm = document.getElementById('kt_modal_add_invoice_item_body')
        if (elm) {
          elm.scrollTop = 0
        }
      }, 100)
    }
  }, [productId])

  useEffect(() => {
    if (isLoaded) {
      if (!(invoiceItem.invoiceItem && isNotEmpty(invoiceItem.invoiceItem))) {
        setDescription(product?.nm || '')
        setFee((product?.pr ?? '').toString())

        setWageRate(product?.wgr?.toString().trim() || '0')
        setProfitRate(product?.prfr?.toString().trim() || '0')
        setCommissionRate(product?.cmtr?.toString().trim() || '0')
        setWageShow(product?.wgs || true)
        setProfitShow(product?.prfs || true)
        setCommissionShow(product?.cmts || true)
        setGoldCostPriceCalculation(undefined)
        setGoldCostPriceError('')
        setOnPercent(true)

        setUnit({
          label: unitLabelOf(product?.un, product?.uni, product),
          value: product?.uni || 1,
        })
        setVatRate(forceZeroVat ? 0 : product?.vtr || 0)
        setVatRateManuallyChanged(false)
      }
    }
  }, [product])

  useEffect(() => {
    if (forceZeroVat && vatRate != 0) {
      setVatRate(0)
      setVatRateManuallyChanged(false)
    }
  }, [forceZeroVat, vatRate])

  const setVatRateFromUser: Dispatch<SetStateAction<number>> = (value) => {
    const nextValue = typeof value === 'function' ? value(vatRate) : value
    const parsedValue = Number(nextValue)
    const normalizedValue = Number.isFinite(parsedValue) ? parsedValue : 0
    const automaticRate = forceZeroVat ? 0 : Number(product?.vtr || 0)
    setVatRate(normalizedValue)
    setVatRateManuallyChanged(normalizedValue !== automaticRate)
  }
  const maxPrice = isPOS ? 9 * Math.pow(10, 12) : 9 * Math.pow(10, 15)
  useEffect(() => {
    if (template11) return
    if (getPrice() > maxPrice) {
      setFee(Math.floor(maxPrice / (parseFloat(qty) || 1)).toString())
    }
  }, [fee])

  useEffect(() => {
    if (template11) return
    if (getPrice() > maxPrice) {
      setQty(Math.floor(maxPrice / (parseFloat(fee) || 1)).toString())
    }
  }, [qty])

  useEffect(() => {
    if (template11 && isNotEmpty(adis) && Number(adis) > maxPrice) {
      setAdis(maxPrice.toString())
    }
  }, [adis])

  const template11Qty = amountMustEqualOne ? 1 : parseFloat(qty)
  const template11QtyValid = Number.isFinite(template11Qty) && template11Qty > 0
  const template11AdisValid = isValidTemplate11Adis(adis) && Number(adis) <= maxPrice
  const template11UnitAmount =
    template11 && template11AdisValid && template11QtyValid
      ? resolveTemplate11UnitAmount(adis, template11Qty)
      : undefined
  const template11AdisError =
    !template11 || !isNotEmpty(adis)
      ? ''
      : !template11AdisValid
      ? TEMPLATE_11_ADIS_WHOLE_NUMBER_ERROR
      : template11QtyValid && template11UnitAmount === undefined
      ? TEMPLATE_11_TOO_LARGE_ERROR
      : ''

  useEffect(() => {
    if (!first && isNotEmpty(discount)) {
      let dis = fixZero(parseFloat(discount))
      const prc = getPrice()
      if (dis > prc) {
        dis = prc
      }
      setDiscount(dis.toString())
    }
  }, [discount])
  useEffect(() => {
    if (!first && isNotEmpty(wage)) {
      setWage(fixZero(parseFloat(wage)).toString())
    }
  }, [wage])
  useEffect(() => {
    if (!first && isNotEmpty(carat)) {
      setCarat(fixZero(parseFloat(carat)).toString())
    }
  }, [carat])
  useEffect(() => {
    if (!first && isNotEmpty(profit)) {
      setProfit(fixZero(parseFloat(profit)).toString())
    }
  }, [profit])
  useEffect(() => {
    if (!first && isNotEmpty(commission)) {
      setCommission(fixZero(parseFloat(commission)).toString())
    }
  }, [commission])

  useEffect(() => {
    if (govTaxRate) {
      if (parseFloat(govTaxRate) > 100) {
        setGovTaxRate('100')
        return
      }
      if (parseFloat(govTaxRate) < 0) {
        setGovTaxRate('0')
        return
      }
      setGovTaxRate(parseFloat(govTaxRate).toString())
    }
  }, [govTaxRate])

  useEffect(() => {
    if (taxRate) {
      if (parseFloat(taxRate) > 100) {
        setTaxRate('100')
        return
      }
      if (parseFloat(taxRate) < 0) {
        setTaxRate('0')
        return
      }
      setTaxRate(parseFloat(taxRate).toString())
    }
  }, [taxRate])

  useEffect(() => {
    if (vatRate) {
      if (vatRate > 100) {
        setVatRate(100)
        return
      }
      if (vatRate < 0) {
        setVatRate(0)
        return
      }
      setVatRate(vatRate)
    }
  }, [vatRate])

  const isPositiveDecimal = (value: string) => {
    const normalized = value.trim()
    return (
      /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(normalized) &&
      !/^0*(?:\.0*)?$/.test(normalized)
    )
  }

  const isZeroOrEmpty = (value: string) => {
    const normalized = value.trim()
    return normalized === '' || /^0*(?:\.0*)?$/.test(normalized)
  }

  const isGoldCostPriceEntryStage =
    formType == 2 && invoiceTemplate == 3 && isZeroOrEmpty(qty)
  const canCalculateGoldCostPrice =
    isPositiveDecimal(total) &&
    isPositiveDecimal(fee) &&
    isValidGoldQuantityDecimalPlaces(goldQuantityDecimalPlaces)
  const isGoldCalculationCurrent =
    goldCostPriceCalculation != undefined &&
    fee === goldCostPriceCalculation.unitPrice &&
    qty === goldCostPriceCalculation.quantity &&
    discount === goldCostPriceCalculation.discount &&
    wage === goldCostPriceCalculation.wage &&
    profit === goldCostPriceCalculation.profit &&
    commission === goldCostPriceCalculation.commission &&
    goldQuantityDecimalPlaces === goldCostPriceCalculation.quantityDecimalPlaces.toString() &&
    String(vatRate) === goldCostPriceCalculation.vatRate &&
    isZeroOrEmpty(taxRate) &&
    isZeroOrEmpty(govTaxRate)

  const resetSelectedProduct = () => {
    setProductSelected(undefined)
    setProductId(undefined)
    setProduct(undefined)
    setDescription(undefined)
    setFee('')
    setQty('')
    setDiscount('')
    setWage('')
    setProfit('0')
    setCommission('0')
    setGoldCostPriceCalculation(undefined)
    setGoldCostPriceError('')
  }

  const calculateGoldCostPrice = async () => {
    if (!productId || !canCalculateGoldCostPrice) return

    setIsGoldCostPriceCalculating(true)
    setGoldCostPriceError('')
    try {
      const {data} = await axios.post<GoldCostPriceCalculation>(
        `${API_URL}/invoices/calculate-gold-cost-price`,
        {
          productId,
          invoiceDate,
          targetNetPrice: total,
          unitPrice: fee,
          wagePercent: wageRate.trim() || '0',
          profitPercent: profitRate.trim() || '0',
          commissionPercent: commissionRate.trim() || '0',
          quantityDecimalPlaces: Number(goldQuantityDecimalPlaces),
        }
      )

      setFee(data.unitPrice)
      setQty(data.quantity)
      setDiscount(data.discount)
      setWage(data.wage)
      setProfit(data.profit)
      setCommission(data.commission)
      setVatRate(Number(data.vatRate))
      setVatRateManuallyChanged(false)
      setOnPercent(false)
      setGoldQuantityDecimalPlaces(data.quantityDecimalPlaces.toString())
      saveGoldQuantityDecimalPlacesPreference(
        data.quantityDecimalPlaces.toString(),
        currentUser?.id,
        currentUser?.cpi
      )
      setGoldCostPriceCalculation(data)
    } catch (error) {
      setGoldCostPriceError(
        getInvoiceErrorMessage(
          error,
          'محاسبه میزان و تخفیف برای مبلغ نهایی واردشده امکان‌پذیر نبود.'
        )
      )
    } finally {
      setIsGoldCostPriceCalculating(false)
    }
  }

  const getPrice: () => number = () => {
    if (template11) {
      return template11AdisValid ? Number(adis) : 0
    }

    if (isGoldCalculationCurrent && goldCostPriceCalculation) {
      return Number(goldCostPriceCalculation.price)
    }

    if (invoiceTemplate == 2) {
      return fixZero((parseFloat(amountCurrency) || 0) * (parseFloat(currencyRate) || 0))
    }

    if (invoiceTemplate == 7) {
      return fixZero(parseFloat(fee) || 0)
    }

    return fixZero((parseFloat(fee) || 0) * (parseFloat(qty) || 0))
  }

  const getAdPrice: () => number = () => {
    if (template11) {
      return getPrice()
    }

    if (isGoldCalculationCurrent && goldCostPriceCalculation) {
      return Number(goldCostPriceCalculation.adPrice)
    }

    let price = getPrice() - fixZero(parseFloat(discount) || 0)
    if (invoiceTemplate == 3) {
      price += (parseFloat(wage) || 0) + (parseFloat(profit) || 0) + (parseFloat(commission) || 0)
    }
    return price
  }
  const getVatPrice: () => number = () => {
    if (isGoldCalculationCurrent && goldCostPriceCalculation) {
      return Number(goldCostPriceCalculation.vatPrice)
    }

    if (forceZeroVat) {
      return 0
    }

    const vatBase =
      invoiceTemplate == 2 || (invoiceTemplate == 9 && parseFloat(vatBaseAmount) > 0)
        ? parseFloat(vatBaseAmount) || 0
        : getAdPrice()
    let vat = vatBase * ((vatRate || 0) / 100)
    if (invoiceTemplate == 3) {
      const _sum =
        (parseFloat(wage) || 0) + (parseFloat(profit) || 0) + (parseFloat(commission) || 0)
      if (invoiceDate.startsWith('1404/') || invoiceDate.startsWith('1405/')) {
        vat += Math.floor(parseFloat((_sum * 0.1).toString()))
      } else {
        vat += Math.floor(parseFloat((_sum * 0.09).toString()))
      }
    }
    return fixZero(vat)
  }
  const getTaxPrice: () => number = () => {
    if (template11) return 0
    return fixZero(getAdPrice() * (parseFloat(taxRate) / 100)) || 0
  }
  const getGovTaxPrice: () => number = () => {
    if (template11) return 0
    return fixZero(getAdPrice() * (parseFloat(govTaxRate) / 100)) || 0
  }
  const getNetPrice: () => number = () => {
    if (isGoldCalculationCurrent && goldCostPriceCalculation) {
      return Number(goldCostPriceCalculation.netPrice)
    }

    const netPrice = getAdPrice() + getVatPrice() + getTaxPrice() + getGovTaxPrice()
    return netPrice
  }
  const optionalNumber = (value: string) => (isNotEmpty(value) ? parseFloat(value) : undefined)
  const goldAmount = (value: string) => {
    const parsedValue = parseFloat(value)
    return Number.isFinite(parsedValue) ? parsedValue : 0
  }
  const save = () => {
    if (contractNoError || amountCurrencyError) return

    const id =
      invoiceItem.invoiceItem && isNotEmpty(invoiceItem.invoiceItem)
        ? invoiceItem.invoiceItem.id
        : fixZero(Math.random() * 952413) * -1
    const normalizedVatRate = forceZeroVat ? 0 : Number(vatRate)
    const newValue = {
      id: id,

      productId: productId,
      product: product || {},

      description: description,
      amount: parseFloat(fee),
      unit: unit,
      qty: amountMustEqualOne ? 1 : parseFloat(qty),
      discount: parseFloat(discount),
      contractNo:
        thirdPartyContractNumberVisible && contractNo ? parseFloat(contractNo) : undefined,
      wage: invoiceTemplate == 3 ? goldAmount(wage) : optionalNumber(wage),
      profit: invoiceTemplate == 3 ? goldAmount(profit) : optionalNumber(profit),
      commission: invoiceTemplate == 3 ? goldAmount(commission) : optionalNumber(commission),
      carat: parseFloat(carat),
      totalDiscount: 0,

      currency: currency,
      currencyId: currency ? Number(currency.value) : undefined,
      currencyRate: parseFloat(currencyRate),
      amountCurrency: invoiceTemplate == 7 ? parseFloat(currencyValue) : parseFloat(amountCurrency),
      currencyValue: parseFloat(currencyValue),
      currencyPurchaseRate: optionalNumber(currencyPurchaseRate),
      vatBaseAmount: optionalNumber(vatBaseAmount),
      weight: optionalNumber(weight),

      price: getPrice(),
      adPrice: getAdPrice(),

      vatRate: normalizedVatRate,
      vatRateManuallyChanged: forceZeroVat ? false : vatRateManuallyChanged,
      vatPrice: forceZeroVat ? 0 : getVatPrice(),

      govTaxName: govTaxName,
      govTaxRate: parseFloat(govTaxRate),
      govTaxPrice: getGovTaxPrice(),

      taxName: taxName,
      taxRate: parseFloat(taxRate),
      taxPrice: getTaxPrice(),

      netPrice: getNetPrice(),
    }
    // الگوی ۱۱: adis عیناً ذخیره می‌شود؛ amount طوری محاسبه می‌شود که floor(amount × qty) == adis
    const rowToSave: InvoiceRowForm = template11
      ? toTemplate11SubmitRow({
          id: id,
          productId: productId,
          product: product || {},
          description: description,
          unit: unit,
          qty: template11Qty,
          adis: Number(adis),
          // عیار در الگوی ۱۱ اختیاری است؛ پیش‌فرض ۷۵۰ فرم طلا برای آن ساخته نمی‌شود
          carat:
            (invoiceItem.invoiceItem?.carat || 0) > 0 ? invoiceItem.invoiceItem?.carat : undefined,
        })
      : newValue
    const ind = items.items.findIndex((x) => x.id == id)
    if (ind >= 0) {
      items.items.splice(ind, 1)
    }
    items.setItems([...items.items, rowToSave])
    invoiceItem.setInvoiceItem(undefined)
  }
  const deleteRow = () => {
    if (invoiceItem.invoiceItem && isNotEmpty(invoiceItem.invoiceItem)) {
      const id = invoiceItem.invoiceItem.id
      const ind = items.items.findIndex((x) => x.id == id)
      if (ind >= 0) {
        items.items.splice(ind, 1)
      }
      items.setItems([...[], ...items.items])
      invoiceItem.setInvoiceItem(undefined)
    }
  }
  function saveDisabled(): boolean {
    if (template11) {
      return (
        productId == undefined ||
        (unitRequired && !hasOrganizationUnitCode(unit)) ||
        !template11QtyValid ||
        template11UnitAmount === undefined
      )
    }

    return (
      productId == undefined ||
      vatRate == undefined ||
      (unitRequired && !hasOrganizationUnitCode(unit)) ||
      (invoiceTemplate != 2 && !isNotEmpty(fee)) ||
      (invoiceTemplate != 2 && !isNotEmpty(qty)) ||
      (invoiceTemplate != 2 && fee == 'NaN') ||
      (invoiceTemplate != 2 && fee == 'null') ||
      // (invoiceTemplate == 3 &&
      //   (!isNotEmpty(wage) ||
      //     !isNotEmpty(profit) ||
      //     !isNotEmpty(commission) ||
      //     wage == 'NaN' ||
      //     profit == 'NaN' ||
      //     commission == 'NaN')) ||
      (invoiceTemplate == 2 &&
        (!isNotEmpty(amountCurrency) ||
          !isNotEmpty(currencyRate) ||
          !isNotEmpty(currencyPurchaseRate) ||
          !isNotEmpty(vatBaseAmount) ||
          !currency ||
          parseFloat(amountCurrency) <= 0 ||
          parseFloat(currencyRate) <= 0 ||
          parseFloat(currencyPurchaseRate) <= 0 ||
          parseFloat(currencyPurchaseRate) >= parseFloat(currencyRate))) ||
      (invoiceTemplate == 7 &&
        (!isNotEmpty(fee) ||
          !isNotEmpty(currencyValue) ||
          !isNotEmpty(currencyRate) ||
          !currency ||
          parseFloat(fee) <= 0 ||
          parseFloat(currencyValue) <= 0 ||
          parseFloat(currencyRate) <= 0)) ||
      getNetPrice() < 0 ||
      contractNoError !== '' ||
      amountCurrencyError !== ''
    )
  }

  const isEditing = !!invoiceItem.invoiceItem && isNotEmpty(invoiceItem.invoiceItem)
  const saveLabel = isEditing ? 'ذخیره تغییرات' : 'افزودن'
  const unitFieldHidden = (_isAPP && !(template11 && unitRequired)) || !unitVisible
  const goldRoundingAvailable = isMegaPay && invoiceTemplate == 3

  // The phone footer's total: the same getNetPrice as totalSum, with the gold rounding calculator on a tap.
  const totalSumCompact = () => {
    const content = (
      <>
        <span className='mp-invoice-item-actions__total-label'>جمع کل</span>
        <strong>
          {numberWithCommas(getNetPrice())} <small>ریال</small>
          {goldRoundingAvailable && (
            <i className='las la-calculator link-warning fs-3 ms-1' aria-hidden='true'></i>
          )}
        </strong>
      </>
    )

    return goldRoundingAvailable ? (
      <button
        type='button'
        className='mp-invoice-item-actions__total'
        title='گرد کردن مبلغ'
        onClick={() => setRounding(true)}
      >
        {content}
      </button>
    ) : (
      <div className='mp-invoice-item-actions__total'>{content}</div>
    )
  }

  const totalSum = () => {
    return (
      <>
        <div
          className='border border-dashed p-5 border-primary rounded bg-light-primary'
          onClick={() => {
            if (isMegaPay && invoiceTemplate == 3) {
              setRounding(true)
            }
          }}
        >
          <div className='text-center fs-4'>
            جمع کل کالا/خدمت:{' '}
            <div className='text-primary fw-bolder fs-2 ms-2'>
              {numberWithCommas(getNetPrice())} ریال
              {isMegaPay && invoiceTemplate == 3 && (
                <i className='las la-calculator link-warning fs-2x ms-5'></i>
              )}
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className='row'>
        {/* <div
          className={`col-xl-${productId && product && product.stin ? '6' : '12'} mt-5 col-lg-12`}
        >
          <SearchSelect
            section='product'
            label='کالا/خدمت'
            isRequired
            stateValue={{value: productSelected, setValue: setProductSelected}}
            defaultvalue={invoiceItem.invoiceItem?.productId}
          >
            <a
              className='d-none d-xl-block'
              href='#'
              onClick={() => {
                setvariableC(null)
              }}
            >
              <i className='las la-plus-square fs-3x text-success'></i>
            </a>
          </SearchSelect>
        </div>
        <div className='col-6 d-none d-xl-block'>
          {productId && product && product.stin && (
            <div className='border border-dashed border-success p-5'>
              <StuffIdInfo stuffidInfo={product.stin} />
            </div>
          )}
        </div> */}
        {!productId && (
          <StepProduct
            productSelected={{
              productSelected,
              setProductSelected,
            }}
            invoiceDate={invoiceDate}
          />
        )}
        {productId ? (
          <>
            {!isGoldCostPriceEntryStage && (
              <div className='col-xl-6 col-md-12 px-2'>
                {/* On a phone or tablet the goods ID box (about 170px) is one line with its details on a tap (509). */}
                <div
                  className={clsx('mp-invoice-item-stuff', {
                    'has-summary': !!product,
                    'is-open': stuffInfoOpen,
                  })}
                >
                  {product && (
                    <button
                      type='button'
                      className='mp-invoice-item-stuff__summary d-lg-none'
                      aria-expanded={stuffInfoOpen}
                      aria-controls='mp-invoice-item-stuff-info'
                      onClick={() => setStuffInfoOpen((open) => !open)}
                    >
                      <span className='mp-invoice-item-stuff__facts'>
                        <bdi dir='ltr' className='mp-invoice-item-stuff__code'>
                          {product.stin?.cd || '-'}
                        </bdi>
                        {product.stin?.sg && <span>{product.stin.sg}</span>}
                        {product.stin?.rt != undefined && (
                          <span>ارزش افزوده {toPersianDigits(product.stin.rt)}٪</span>
                        )}
                      </span>
                      <span className='mp-invoice-item-stuff__toggle'>
                        {stuffInfoOpen ? 'بستن' : 'جزئیات'}
                        <i
                          className={clsx('las', stuffInfoOpen ? 'la-angle-up' : 'la-angle-down')}
                          aria-hidden='true'
                        ></i>
                      </span>
                    </button>
                  )}
                  <div
                    id='mp-invoice-item-stuff-info'
                    className='border border-dashed border-primary rounded bg-light-primary mp-invoice-item-stuff-info'
                  >
                    {product ? (
                      <StuffIdInfo stuffidInfo={product.stin || {}} />
                    ) : (
                      <div className='text-center w-100 m-5'>در حال پردازش...</div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {isGoldCostPriceEntryStage ? (
              <GoldCostPriceEntryStep
                productName={product?.nm || description || ''}
                total={{value: total, setValue: setTotal}}
                unitPrice={{value: fee, setValue: setFee}}
                wagePercent={{value: wageRate, setValue: setWageRate}}
                profitPercent={{value: profitRate, setValue: setProfitRate}}
                commissionPercent={{value: commissionRate, setValue: setCommissionRate}}
                quantityDecimalPlaces={{
                  value: goldQuantityDecimalPlaces,
                  setValue: setGoldQuantityDecimalPlaces,
                }}
                isCalculating={isGoldCostPriceCalculating}
                canContinue={canCalculateGoldCostPrice}
                onChangeProduct={resetSelectedProduct}
                onContinue={calculateGoldCostPrice}
              />
            ) : !template11 && formType == 2 && (!isNotEmpty(qty) || Number(qty) == 0) ? (
              <>
                <div className='col-12'></div>
                <div className='col-xl-6 col-lg-12 mt-5'>
                  <CustomInputs
                    type='currency'
                    label={'مبلغ نهایی را وارد کنید'}
                    stateValue={{
                      value: total,
                      setValue: setTotal,
                    }}
                  />
                </div>
                <div className='col-xl-6 col-lg-12 mt-5'>
                  <CustomInputs
                    type='currency'
                    isRequired
                    label={
                      invoiceTemplate == 7
                        ? 'ارزش ریالی کالا'
                        : invoiceTemplate == 3
                        ? 'قیمت پایه'
                        : 'قیمت واحد'
                    }
                    stateValue={{value: fee, setValue: setFee}}
                  >
                    {invoiceTemplate == 3 && (
                      <div className='input-group-prepend'>
                        <span
                          className='form-control form-control-solid py-lg-2 p-1 px-5 bg-primary fw-bolder'
                          style={{
                            borderRightWidth: '0px',
                            borderTopRightRadius: '0px',
                            borderBottomRightRadius: '0px',
                          }}
                          onClick={() => {
                            setPriceCalShow(true)
                          }}
                        >
                          <i
                            className='las la-calculator text-white'
                            style={{fontSize: '35px'}}
                          ></i>
                        </span>
                      </div>
                    )}
                  </CustomInputs>
                </div>
                <div>
                  <button
                    className='btn btn-success w-100 mt-10'
                    disabled={!isNotEmpty(total) || total == '0' || !isNotEmpty(fee) || fee == '0'}
                    onClick={() => {
                      if (product?.nm?.includes('سکه')) {
                        setQty(Math.ceil(Number(total) / Number(fee)).toString())
                      } else {
                        // let pr = 0
                        // let wg = 0
                        // if (!isNotEmpty(profit)) {
                        //   pr = Math.ceil(Number(total) * (Number(product?.prfr) / 100))
                        //   setProfit(pr.toString())
                        // }
                        // if (!isNotEmpty(wage)) {
                        //   wg = Math.ceil(Number(total) * (Number(product?.wgr) / 100))
                        //   setWage(wg.toString())
                        // }
                        // if (!isNotEmpty(commission)) {
                        //   setCommission('0')
                        // }
                        // const vt = (wg + pr) * 1.09
                        // setQty(Math.ceil((Number(total) - wg - pr - vt) / Number(fee)).toString())

                        const _fee = Number(fee)
                        const _wg = _fee * (Number(product?.wgr) / 100)
                        const _pr = (_wg + _fee) * (Number(product?.prfr) / 100)
                        const _cm = _fee * (Number(product?.cmtr) / 100)
                        const _vt = (_cm + _pr + _wg) * 0.1
                        const qt =
                          Math.ceil((Number(total) / (_fee + _wg + _pr + _cm + _vt)) * 10000) /
                          10000
                        setQty(qt.toString())
                      }
                    }}
                  >
                    ادامه
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className='col-xl-6 col-md-12 mt-5'>
                  <CustomInputs
                    type='text'
                    label='شرح کالا/خدمت در صورتحساب'
                    // hint={
                    //   <span className='fs-5 text-gray-600'>
                    //     {isNotEmpty(product.cd) && product.cd != product.sti && product.cd}
                    //   </span>
                    // }
                    stateValue={{value: description, setValue: setDescription}}
                  />
                </div>
                {template11 && (
                  <>
                    <div className='col-xl-6 col-lg-12 mt-5'>
                      <CustomInputs
                        type='currency'
                        isRequired
                        label='مبلغ بعد از تخفیف (ارزش معامله در اعلامیه فروش بورس)'
                        hint='عیناً برابر ارزش معامله در اعلامیه فروش بورس؛ عدد صحیح ریال'
                        error={template11AdisError || undefined}
                        stateValue={{value: adis, setValue: setAdis}}
                      />
                    </div>
                    <div className='col-xl-6 col-lg-12 mt-5'>
                      <CustomInputs
                        key={template11UnitAmount ?? ''}
                        type='currency'
                        LTR
                        isDisabled
                        label='مبلغ واحد (محاسباتی – به سامانه ارسال نمی‌شود)'
                        value={template11UnitAmount ?? ''}
                      />
                    </div>
                  </>
                )}
                {/* What is typed comes first, two a row (509): quantity beside the unit price, the unit under the
                    quantity, the discount under the price; the computed amounts follow. */}
                <div
                  className={
                    template11 ? 'col-xl-6 col-lg-12 mt-5' : 'col-6 mt-5 mp-invoice-item-half'
                  }
                >
                  <CustomInputs
                    type='number'
                    isRequired
                    label={
                      <>
                        {invoiceTemplate == 3 ? (
                          <>
                            {product?.nm?.includes('سکه') && !product?.nm?.includes('پارسیان') ? (
                              <>تعداد</>
                            ) : (
                              <>
                                وزن <span className='text-gray-500 fs-7'>(گرم)</span>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            تعداد / مقدار
                            {/* The unit field sits right under this one on a phone. */}
                            <span
                              className={clsx('text-gray-500 fs-7', {
                                'd-none d-sm-inline': !unitFieldHidden,
                              })}
                            >{` (${unit?.label})`}</span>
                          </>
                        )}
                      </>
                    }
                    stateValue={{value: qty, setValue: setQty}}
                    isDisabled={amountMustEqualOne}
                    hint={
                      amountMustEqualOne ? 'طبق قواعد V7.9 مقدار این ردیف باید ۱ باشد.' : undefined
                    }
                  />
                </div>
                {!template11 && (
                  <div className='col-6 mt-5 mp-invoice-item-half'>
                    <CustomInputs
                      type='currency'
                      isRequired
                      label={
                        invoiceTemplate == 7
                          ? 'ارزش ریالی کالا'
                          : invoiceTemplate == 3
                          ? 'قیمت پایه'
                          : 'قیمت واحد'
                      }
                      stateValue={{value: fee, setValue: setFee}}
                    >
                      {invoiceTemplate == 3 && (
                        <div className='input-group-prepend'>
                          <span
                            className='form-control form-control-solid py-lg-2 p-1 px-5 bg-primary fw-bolder'
                            style={{
                              borderRightWidth: '0px',
                              borderTopRightRadius: '0px',
                              borderBottomRightRadius: '0px',
                            }}
                            onClick={() => {
                              setPriceCalShow(true)
                            }}
                          >
                            <i
                              className='las la-calculator text-white'
                              style={{fontSize: '35px'}}
                            ></i>
                          </span>
                        </div>
                      )}
                    </CustomInputs>
                  </div>
                )}
                <div
                  className={clsx('col-6 mt-5', {
                    'mp-invoice-item-half': !template11,
                    // واحد الزامی الگوی ۱۱ (mu) در فرم ساده هم باید قابل اصلاح باشد
                    'd-none': unitFieldHidden,
                  })}
                >
                  <SearchSelect
                    section='unit'
                    isRequired={unitRequired}
                    isDisabled={unitRule.readOnly}
                    label='واحد اندازه‌گیری'
                    stateValue={{value: unit, setValue: setUnit}}
                    error={
                      unitRequired && unit && !hasOrganizationUnitCode(unit)
                        ? 'برای این الگو، واحدی را انتخاب کنید که کد معتبر سامانه مؤدیان داشته باشد.'
                        : undefined
                    }
                    hint={
                      unitRequired ? (
                        'فیلد واحد اندازه‌گیری (mu) در این الگو الزامی است.'
                      ) : unitRule.readOnly ? (
                        'واحد اندازه‌گیری از صورتحساب مرجع دریافت شده و قابل ویرایش نیست.'
                      ) : isCodelessUnitLabel(unit?.label) ? (
                        <span className='text-warning-emphasis' role='status'>
                          <i className='las la-exclamation-triangle me-1' aria-hidden='true'></i>
                          {CODELESS_UNIT_HINT}
                        </span>
                      ) : undefined
                    }
                  />
                </div>
                {!template11 && (
                  <div className='col-6 mt-5 mp-invoice-item-half'>
                    <CustomInputs
                      type='currency'
                      label='تخفیف'
                      stateValue={{value: discount, setValue: setDiscount}}
                    />
                  </div>
                )}
                {formType == 0 && invoiceTemplate == 2 && (
                  <>
                    <div className='col-xl-6 col-lg-12 mt-5'>
                      <CustomInputs
                        type='number'
                        label='میزان ارز'
                        isRequired={invoiceTemplate == 2}
                        error={amountCurrencyError}
                        stateValue={{value: amountCurrency, setValue: setAmountCurrency}}
                      />
                    </div>
                    <div className='col-xl-6 col-lg-12 mt-5'>
                      <SearchSelect
                        section='currency'
                        label='نوع ارز'
                        isRequired={invoiceTemplate == 2}
                        stateValue={{value: currency, setValue: setCurrency}}
                      />
                    </div>
                    <div className='col-xl-6 col-lg-12 mt-5'>
                      <CustomInputs
                        type='number'
                        isRequired={invoiceTemplate == 2}
                        label={invoiceTemplate == 2 ? 'نرخ فروش ارز' : 'نرخ برابری ارز با ریال'}
                        stateValue={{value: currencyRate, setValue: setCurrencyRate}}
                      />
                    </div>
                  </>
                )}
                {invoiceTemplate == 7 && (
                  <>
                    <div className='col-xl-6 col-lg-12 mt-5'>
                      <CustomInputs
                        type='number'
                        isRequired
                        label='ارزش ارزی کالا'
                        stateValue={{value: currencyValue, setValue: setCurrencyValue}}
                      />
                    </div>
                    <div className='col-xl-6 col-lg-12 mt-5'>
                      <SearchSelect
                        section='currency'
                        label='نوع ارز'
                        isRequired
                        stateValue={{value: currency, setValue: setCurrency}}
                      />
                    </div>
                    <div className='col-xl-6 col-lg-12 mt-5'>
                      <CustomInputs
                        type='number'
                        isRequired
                        label='نرخ برابری ارز با ریال'
                        stateValue={{value: currencyRate, setValue: setCurrencyRate}}
                      />
                    </div>
                  </>
                )}
                {invoiceTemplate == 2 && (
                  <>
                    <div className='col-xl-6 col-lg-12 mt-5'>
                      <CustomInputs
                        type='number'
                        isRequired
                        label='نرخ خرید ارز'
                        stateValue={{
                          value: currencyPurchaseRate,
                          setValue: setCurrencyPurchaseRate,
                        }}
                        hint='باید بزرگتر از صفر و کوچکتر از نرخ فروش ارز باشد.'
                      />
                    </div>
                    <div className='col-xl-6 col-lg-12 mt-5'>
                      <CustomInputs
                        type='currency'
                        isRequired
                        label='ماخذ مالیات بر ارزش افزوده در الگوی فروش ارز'
                        stateValue={{value: vatBaseAmount, setValue: setVatBaseAmount}}
                        hint='بازه مجاز: میزان ارز × (نرخ فروش - نرخ خرید) تا میزان ارز × نرخ فروش.'
                      />
                    </div>
                  </>
                )}
                {/* {isNotEmpty(qty) && parseFloat(qty) > 0 && ( */}
                {/* key={`${getPrice()}`} */}
                <Fragment>
                  {invoiceTemplate == 3 && !product?.nm?.includes('سکه') && (
                    <div className='col-xl-6 col-lg-12 mt-5'>
                      <CustomInputs
                        type='number'
                        label='عیار'
                        max={3}
                        stateValue={{value: carat, setValue: setCarat}}
                      />
                    </div>
                  )}
                  {/* Below 992 these read-only amounts are the summary under the VAT rate (509). */}
                  {formType == 0 && !template11 && (
                    <>
                      <div className={clsx('col-lg-6 mt-5 d-none d-lg-block')}>
                        <CustomInputs
                          type='currency'
                          LTR
                          isDisabled
                          label='مبلغ قبل از تخفیف'
                          value={getPrice().toString()}
                        />
                      </div>
                      <div
                        className={clsx('col-lg-6 mt-5', _isAPP ? 'd-none' : 'd-none d-lg-block')}
                      >
                        <CustomInputs
                          type='currency'
                          LTR
                          isDisabled
                          label='مبلغ بعد از تخفیف'
                          value={getAdPrice().toString()}
                        />
                      </div>
                    </>
                  )}
                  {invoiceTemplate == 3 && (
                    <>
                      <Template3Fields
                        getPrice={getPrice}
                        wage={{
                          wage: wage,
                          setWage: setWage,
                          rate: wageRate,
                          show: wageShow,
                        }}
                        profit={{
                          profit: profit,
                          setProfit: setProfit,
                          rate: profitRate,
                          show: profitShow,
                        }}
                        commission={{
                          commission: commission,
                          setCommission: setCommission,
                          rate: commissionRate,
                          show: commissionShow,
                        }}
                        onPercent={onPercent}
                        displayRates={goldCostPriceCalculation != undefined}
                      />
                      {formType == 0 && (
                        <>
                          <div className='col-xl-6 col-lg-12 mt-5'>
                            <CustomInputs
                              type='number'
                              isReadonly
                              isDisabled
                              label='نرخ مالیات بر ارزش افزوده - الگوی طلا و جواهر'
                            />
                          </div>
                          <div className='col-xl-6 col-lg-12 mt-5'>
                            <CustomInputs
                              type='number'
                              isReadonly
                              isDisabled
                              label='مبلغ مالیات بر ارزش افزوده - الگوی طلا و جواهر'
                            />
                          </div>
                        </>
                      )}
                    </>
                  )}
                  <div className={clsx('col-6 mt-5', {'d-none': _isAPP})}>
                    <CustomInputs
                      type='number'
                      LTR
                      //isDisabled
                      isDisabled={forceZeroVat}
                      label='نرخ مالیات بر ارزش افزوده'
                      stateValue={{
                        setValue: setVatRateFromUser,
                        value: vatRate,
                      }}
                      hint={
                        invoiceTemplate == 14
                          ? 'طبق سند V7.9 نرخ م.ا.ا در الگوی فروش زنجیره باید صفر باشد.'
                          : zeroVatTemplate
                          ? 'طبق سند V7.9 نرخ VAT برای الگوهای صادرات و بورس کالا صفر است.'
                          : forceZeroVat
                          ? 'برای مودیان فراخوان‌نشده مالیات بر ارزش افزوده، نرخ قابل قبول صفر است.'
                          : undefined
                      }
                    />
                  </div>
                  <div
                    className={clsx('col-xl-6 col-lg-12 mt-5 d-none d-lg-block')}
                    key={getVatPrice()}
                  >
                    <CustomInputs
                      type='currency'
                      isDisabled
                      label={
                        <>
                          مبلغ مالیات بر ارزش افزوده <span className='ms-2'>{vatRate}%</span>
                        </>
                      }
                      value={getVatPrice().toString()}
                    />
                  </div>
                  {/* The same getPrice/getAdPrice/getVatPrice values as the read-only fields above, two a row on a
                      phone or tablet instead of three 44px disabled inputs (509). */}
                  <div className='col-12 mt-5 d-lg-none'>
                    <dl className='mp-invoice-item-computed'>
                      {formType == 0 && !template11 && (
                        <div>
                          <dt>مبلغ قبل از تخفیف</dt>
                          <dd>
                            {numberWithCommas(getPrice())} <small>ریال</small>
                          </dd>
                        </div>
                      )}
                      {formType == 0 && !template11 && !_isAPP && (
                        <div>
                          <dt>مبلغ بعد از تخفیف</dt>
                          <dd>
                            {numberWithCommas(getAdPrice())} <small>ریال</small>
                          </dd>
                        </div>
                      )}
                      <div>
                        <dt>مالیات بر ارزش افزوده ({toPersianDigits(vatRate || 0)}٪)</dt>
                        <dd>
                          {numberWithCommas(getVatPrice())} <small>ریال</small>
                        </dd>
                      </div>
                    </dl>
                  </div>
                  {hasAdditionalFields && (
                    <div className='col-12 mt-5'>
                      <div className='mp-invoice-item-additional rounded border border-dashed'>
                        <button
                          type='button'
                          className='mp-invoice-item-additional__toggle'
                          aria-expanded={showAdditionalFields}
                          aria-controls='invoice-item-additional-fields'
                          onClick={() => setShowAdditionalFields((value) => !value)}
                        >
                          <span>
                            <span className='d-block fw-bold text-gray-800'>
                              اطلاعات تکمیلی و کم‌کاربرد
                            </span>
                            <span className='d-block fs-8 text-gray-600 mt-1'>
                              ارز، سایر مالیات و عوارض، وجوه قانونی و اطلاعات قرارداد
                            </span>
                          </span>
                          <i
                            className={clsx(
                              'las fs-2 text-primary',
                              showAdditionalFields ? 'la-angle-up' : 'la-angle-down'
                            )}
                            aria-hidden='true'
                          ></i>
                        </button>
                        {showAdditionalFields && (
                          <div id='invoice-item-additional-fields' className='row px-3 pb-4'>
                            {formType == 0 && !_isAPP && ![2, 5, 7, 11].includes(invoiceTemplate) && (
                              <>
                                <div className='col-xl-6 col-lg-12 mt-5'>
                                  <CustomInputs
                                    type='number'
                                    label='میزان ارز'
                                    error={amountCurrencyError}
                                    stateValue={{
                                      value: amountCurrency,
                                      setValue: setAmountCurrency,
                                    }}
                                  />
                                </div>
                                <div className='col-xl-6 col-lg-12 mt-5'>
                                  <SearchSelect
                                    section='currency'
                                    label='نوع ارز'
                                    stateValue={{value: currency, setValue: setCurrency}}
                                  />
                                </div>
                                <div className='col-xl-6 col-lg-12 mt-5'>
                                  <CustomInputs
                                    type='number'
                                    label='نرخ برابری ارز با ریال'
                                    stateValue={{value: currencyRate, setValue: setCurrencyRate}}
                                  />
                                </div>
                              </>
                            )}
                            {invoiceTemplate == 7 && (
                              <div className='col-xl-6 col-lg-12 mt-5'>
                                <CustomInputs
                                  type='number'
                                  label='وزن خالص'
                                  stateValue={{value: weight, setValue: setWeight}}
                                />
                              </div>
                            )}
                            {invoiceTemplate == 9 && (
                              <div className='col-xl-6 col-lg-12 mt-5'>
                                <CustomInputs
                                  type='currency'
                                  label='مبلغ پایه مالیات بر ارزش افزوده'
                                  stateValue={{
                                    value: vatBaseAmount,
                                    setValue: setVatBaseAmount,
                                  }}
                                  hint='برای اقلام مشمول حکم خاص فرآورده‌های نفتی تکمیل شود؛ در صورت خالی بودن، مبلغ بعد از تخفیف مبنای محاسبه VAT است.'
                                />
                              </div>
                            )}
                            {formType == 0 && !_isAPP && (
                              <>
                                <div className='col-xl-6 col-lg-12 mt-5'>
                                  <CustomInputs
                                    type='text'
                                    label='موضوع سایر مالیات و عوارض'
                                    stateValue={{value: taxName, setValue: setTaxName}}
                                  />
                                </div>
                                <div className='col-xl-3 col-md-6 mt-5'>
                                  <CustomInputs
                                    type='number'
                                    label='نرخ سایر مالیات و عوارض'
                                    stateValue={{value: taxRate, setValue: setTaxRate}}
                                  />
                                </div>
                                <div className='col-xl-3 col-md-6 mt-5'>
                                  <CustomInputs
                                    type='currency'
                                    isDisabled
                                    label='مبلغ سایر مالیات و عوارض'
                                    value={getTaxPrice().toString()}
                                  />
                                </div>
                                <div className='col-xl-6 col-lg-12 mt-5'>
                                  <CustomInputs
                                    type='text'
                                    label='موضوع سایر وجوه قانونی'
                                    stateValue={{value: govTaxName, setValue: setGovTaxName}}
                                  />
                                </div>
                                <div className='col-xl-3 col-md-6 mt-5'>
                                  <CustomInputs
                                    type='number'
                                    label='نرخ سایر وجوه قانونی'
                                    stateValue={{value: govTaxRate, setValue: setGovTaxRate}}
                                  />
                                </div>
                                <div className='col-xl-3 col-md-6 mt-5'>
                                  <CustomInputs
                                    type='currency'
                                    isDisabled
                                    label='مبلغ سایر وجوه قانونی'
                                    value={getGovTaxPrice().toString()}
                                  />
                                </div>
                                {thirdPartyContractNumberVisible && (
                                  <div className='col-xl-6 col-lg-12 mt-5'>
                                    <CustomInputs
                                      type='text'
                                      isReadonly={thirdPartyContractNumberReadOnly}
                                      label='شماره قرارداد معامله از طریق شخص ثالث'
                                      hint='در صورت وجود قرارداد معامله از طریق شخص ثالث، شناسه رسمی ۱۲ رقمی آن را وارد کنید؛ شماره داخلی قرارداد معتبر نیست.'
                                      error={contractNoError}
                                      max={THIRD_PARTY_CONTRACT_NUMBER_LENGTH}
                                      LTR
                                      stateValue={{
                                        value: contractNo,
                                        setValue: (value) =>
                                          setContractNo(
                                            normalizeThirdPartyContractNumberInput(value)
                                          ),
                                      }}
                                    />
                                    {!thirdPartyContractNumberReadOnly && (
                                      <ThirdPartyContractPicker
                                        invoiceTemplate={invoiceTemplate}
                                        productionInvoice={productionInvoice}
                                        value={contractNo}
                                        onPick={(contractNumber) =>
                                          setContractNo(
                                            normalizeThirdPartyContractNumberInput(contractNumber)
                                          )
                                        }
                                      />
                                    )}
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className='col-12 my-2 d-none d-lg-block'>{totalSum()}</div>
                  <div className='text-center pt-15 d-none d-lg-block'>
                    <button
                      disabled={saveDisabled()}
                      className='btn btn-success w-25'
                      onClick={save}
                    >
                      <span className='indicator-label'>{saveLabel}</span>
                    </button>

                    {isEditing && (
                      <button className='btn btn-light-danger ms-2' onClick={deleteRow}>
                        <span className='indicator-label'>حذف</span>
                      </button>
                    )}
                  </div>
                  <div className='d-lg-none mp-invoice-form-actions-spacer'></div>
                  {/* One row (509): the item's total beside its buttons; it was 146px with the total boxed above them. */}
                  <nav
                    className='d-lg-none navbar navbar-light shadow bg-light mp-invoice-form-actions mp-invoice-item-actions'
                    aria-label='ذخیره قلم'
                  >
                    {totalSumCompact()}
                    <button
                      disabled={saveDisabled()}
                      className={clsx('btn btn-success flex-grow-1')}
                      onClick={save}
                    >
                      <span className='indicator-label'>{saveLabel}</span>
                    </button>
                    {isEditing && (
                      <button className='btn btn-light-danger' onClick={deleteRow}>
                        <span className='indicator-label'>حذف</span>
                      </button>
                    )}
                  </nav>
                </Fragment>
                {/* )} */}
              </>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
      {variableC !== undefined && <ProductEditModal />}

      {priceCalShow && (
        <GoldPriceCal
          fee={{fee: fee, setFee: setFee}}
          carat={{carat: carat, setCarat: setCarat}}
          popupHandle={{show: priceCalShow, hide: setPriceCalShow}}
        />
      )}

      {rounding && (
        <DiscountPriceCal
          getNetPrice={getNetPrice}
          popupHandle={{show: rounding, hide: setRounding}}
          getPrice={getPrice}
          total={total}
          wage={{
            wage: wage,
            setWage: setWage,
          }}
          commission={{
            commission: commission,
            setCommission: setCommission,
          }}
          profit={{
            profit: profit,
            setProfit: setProfit,
          }}
          discount={{
            discount: discount,
            setDiscount: setDiscount,
          }}
          onPercent={{
            onPercent: onPercent,
            setOnPercent: setOnPercent,
          }}
        />
      )}

      {goldCostPriceError && (
        <Alert
          title='محاسبه ناموفق'
          body={goldCostPriceError}
          help={false}
          cancel={{text: 'بستن', fn: () => setGoldCostPriceError('')}}
        />
      )}
    </>
  )
}

export {InvoiceItemEditModalForm}
